import React from 'react';
import { BreakpointNames } from 'Theme/types/breakpoints.type';

import { List, Item, StyledIcon, Text } from './Columns.styled';

export interface Item {
    id: string;
    text: string;
    icon: React.ElementType;
}

export interface Props {
    items: Item[];
    columns?: Partial<Record<BreakpointNames, number>>;
}

const Columns: React.FC<Props> = ({ items, columns }) => {
    return (
        <List $columns={columns}>
            {items.map(item => (
                <Item key={item.id}>
                    <StyledIcon as={item.icon} />
                    <Text>{item.text}</Text>
                </Item>
            ))}
        </List>
    );
};

export default Columns;
